import { render, staticRenderFns } from "./DetalhesRedeEmpresa.vue?vue&type=template&id=2b568be5&"
import script from "./DetalhesRedeEmpresa.vue?vue&type=script&lang=js&"
export * from "./DetalhesRedeEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesRedeEmpresa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports